import ChecklistIcon from "../ChecklistIcon/ChecklistIcon"
import Chevron from "../Chevron/Chevron"
import { BLUE } from "../../styles/colors"
import {
    Container,
    IconNameContainer,
    IconContainer,
    IconImage,
    NameText,
    BoldNameText,
    GrayNameText
} from "./TopUpOptionItem.styles"
import BankIcon from "../BankIcon/BankIcon"

const TopUpOptionItem = ({
    iconUrl,
    name,
    boldName,
    grayName,
    onClick,
    checked,
    iconPlaceholder,
    id,
    disabled
}: {
    iconUrl: string
    name?: string
    boldName?: string
    grayName?: string
    onClick?: () => void
    checked?: boolean
    iconPlaceholder?: 'bank' | 'crypto'
    id?: string
    disabled?: boolean
}) => {
    return (
        <Container
        onClick={disabled ? undefined : onClick}
        data-testid={`option-item-${id}`}
        style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'default' : 'pointer' }}
    >
            <IconNameContainer>
                <IconContainer $iconPlaceholder={iconPlaceholder}>
                    {!iconPlaceholder && <IconImage src={iconUrl} alt={name} />}
                    {iconPlaceholder === 'bank' && <BankIcon />}
                </IconContainer>
                {name && <NameText>{iconPlaceholder ? `Other ${iconPlaceholder}` : name}</NameText>}
                {boldName && <BoldNameText>{iconPlaceholder ? `Other ${iconPlaceholder}` : boldName}</BoldNameText>}
                {grayName && <GrayNameText>{iconPlaceholder ? `Other ${iconPlaceholder}` : grayName}</GrayNameText>}
            </IconNameContainer>
            {checked && <ChecklistIcon color={BLUE} size={24} strokeWidth={1} />}
            {!checked && <Chevron strokeWidth={1} color={BLUE} />}
        </Container>
    )
}

export default TopUpOptionItem
